import { baseURL } from "../utils/config";
export const INVOICE_HISTORY = `${baseURL}/invoicing/history`;
export const CREATE_INVOICE = `${baseURL}/invoicing/invoice`;
export const PAYMENT_STATS = `${baseURL}/stats`;
export const WALLET_SETTINGS = `${baseURL}/user/payment-settings`;
export const PROFILE_API = `${baseURL}/user/profile`;
export const PROFILE_IMAGE = `${baseURL}/user/profile-image`;
export const UPDATE_USER = `${baseURL}/user/profile`;
export const INVOICE = `${baseURL}/invoicing/invoice`;
export const SEND_PAYMENT = `${baseURL}/invoicing/pay`;
